<template>
    <b-button
      title="Наверх"
      class="alert-go-top"
      :show="scrollY > scrollForGoUp"
      v-if="(scrollY > scrollForGoUp)"
      variant="primary"
      @click="goToUpPage">
      <em class="fas fa-angle-up" />
    </b-button>
</template>

<script>
export default {
  name: 'UpButton',
  data() {
    return {
      scrollY: 0,
      scrollForGoUp: 500,
      widthWindow: null
    }
  },
  mounted() {
    this.widthWindow = window.innerWidth
    window.onresize = () => {
      this.widthWindow = window.innerWidth
    }
    window.onscroll = () => {
      this.scrollY = window.pageYOffset
    }
  },
  methods: {
    goToUpPage() {
      window.scrollBy(0, -this.scrollY)
    }
  }
}
</script>

<style scoped>
.alert-go-top {
  position: fixed;
  bottom: 16px;
  right: 16px;
  border-radius: 25px;
  z-index: 500;
  text-align: center;
}
</style>
